import React from "react"

export const LoadingCell = () => {
  return <div className="loading-cell" />
}
